import { Button } from 'baseui/button';
import { Modal, ModalBody, ModalButton, ModalFooter, ModalHeader } from 'baseui/modal';
import { useState } from 'react';
import { useIntl, FormattedMessage } from 'react-intl';
import CalendarsList from './CalendarsList';
import { TScheduler } from '../../types';
import AddExceptionDialogForm from './AddExceptionDialogForm';
import { ICalendar } from '../../../Calendar';
import { SpecialEventDto } from '../../../../../services/schedulers/types';



export const AddExceptionDialog = (props:
    {
        isOpen: boolean,
        setIsOpen: any,
        onAdd: any,
        app: TScheduler,
        calendarsFilter(calendar: ICalendar): boolean,
    }) => {
    const [selected, setSelected] = useState<any>();

    const onChanged = (eventPrio: number, calendar: ICalendar | undefined) => setSelected({ eventPrio: eventPrio, calendar: calendar });

    return (
        <>
            <Modal closeable onClose={() => props.setIsOpen(false)} isOpen={props.isOpen}>
                <ModalHeader><FormattedMessage id="Scheduler.AddException" defaultMessage="Add a new Exception Schedule" /></ModalHeader>
                <ModalBody>
                    <AddExceptionDialogForm calendarsFilter={props.calendarsFilter} onChanged={onChanged} app={props.app}></AddExceptionDialogForm>
                </ModalBody>
                <ModalFooter>
                    <ModalButton kind="tertiary" onClick={() => { props.setIsOpen(false); }}>
                        <FormattedMessage id="cancel" defaultMessage="Cancel" />
                    </ModalButton>
                    <ModalButton disabled={!selected || !selected.calendar} onClick={() => { props.onAdd(selected); props.setIsOpen(false) }}><FormattedMessage id="add" defaultMessage="Add" /></ModalButton>
                </ModalFooter>
            </Modal>
        </>
    );
}






